import UserLayout from './UserLayout';

const PublicRoute = () => {
  return <UserLayout />;
};

export default PublicRoute;
